<div class="sag-datepicker-header">
  <!-- <button mat-icon-button (click)="previousClicked('year')">
    <mat-icon>keyboard_double_arrow_left</mat-icon>
  </button> -->
  <button (click)="previousClicked('month')" mat-icon-button>
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <span class="sag-datepicker-header-label">{{ periodLabel }}</span>
  <button (click)="nextClicked('month')" mat-icon-button>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <!-- <button mat-icon-button (click)="nextClicked('year')">
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button> -->
</div>
